[
  "America/Mexico_City",
  "Pacific/Tarawa",
  "Africa/Bangui",
  "America/Mendoza",
  "Europe/Belfast",
  "Europe/Warsaw",
  "Asia/Vladivostok",
  "America/Chicago",
  "Africa/Brazzaville",
  "Etc/GMT+6",
  "America/Dawson",
  "Etc/GMT-7",
  "Europe/Vatican",
  "Asia/Tokyo",
  "Atlantic/Stanley",
  "Antarctica/Casey",
  "America/Thule",
  "Pacific/Rarotonga",
  "US/Pacific",
  "Pacific/Truk",
  "America/Manaus",
  "US/Samoa",
  "America/Virgin",
  "Asia/Yekaterinburg",
  "Canada/Yukon",
  "America/Juneau",
  "Pacific/Guadalcanal",
  "Africa/Johannesburg",
  "Pacific/Efate",
  "America/Knox_IN",
  "Asia/Macao",
  "GMT0",
  "America/Port-au-Prince",
  "Australia/Victoria",
  "Europe/Vilnius",
  "Cuba",
  "Europe/Malta",
  "Asia/Ho_Chi_Minh",
  "Asia/Chita",
  "America/Mazatlan",
  "Pacific/Pago_Pago",
  "Turkey",
  "Africa/Asmara",
  "Asia/Chungking",
  "America/Guayaquil",
  "Africa/Blantyre",
  "America/Indiana/Winamac",
  "Asia/Ashkhabad",
  "Asia/Srednekolymsk",
  "Australia/Sydney",
  "America/Winnipeg",
  "Europe/Amsterdam",
  "Asia/Kuala_Lumpur",
  "Africa/El_Aaiun",
  "Asia/Shanghai",
  "Europe/Mariehamn",
  "ROC",
  "Atlantic/Bermuda",
  "Australia/Perth",
  "America/Montserrat",
  "Asia/Famagusta",
  "Australia/West",
  "Pacific/Pohnpei",
  "Asia/Kuwait",
  "Pacific/Wake",
  "America/Jujuy",
  "Pacific/Saipan",
  "America/Aruba",
  "Asia/Bishkek",
  "Asia/Dacca",
  "America/Kentucky/Monticello",
  "America/Shiprock",
  "Jamaica",
  "Australia/Melbourne",
  "Europe/Rome",
  "Etc/Zulu",
  "America/Boa_Vista",
  "America/Cordoba",
  "Europe/Luxembourg",
  "America/Santo_Domingo",
  "America/Managua",
  "Etc/GMT-1",
  "Pacific/Ponape",
  "Asia/Irkutsk",
  "Israel",
  "Canada/Atlantic",
  "Asia/Phnom_Penh",
  "Asia/Tehran",
  "Indian/Mayotte",
  "Asia/Thimphu",
  "Etc/GMT+3",
  "Australia/Darwin",
  "Europe/Tirane",
  "Asia/Jayapura",
  "Etc/GMT-2",
  "America/Argentina/San_Juan",
  "America/Rankin_Inlet",
  "Asia/Aqtobe",
  "Asia/Colombo",
  "Zulu",
  "Europe/Sarajevo",
  "America/Marigot",
  "America/Recife",
  "America/Indiana/Tell_City",
  "Africa/Nouakchott",
  "America/Panama",
  "Antarctica/Macquarie",
  "Europe/Prague",
  "America/Anchorage",
  "America/Inuvik",
  "America/Ojinaga",
  "Brazil/DeNoronha",
  "Asia/Istanbul",
  "Indian/Cocos",
  "Europe/Paris",
  "Pacific/Samoa",
  "Europe/Samara",
  "America/Caracas",
  "Universal",
  "Greenwich",
  "America/Louisville",
  "Asia/Ujung_Pandang",
  "Canada/Mountain",
  "America/Argentina/La_Rioja",
  "Africa/Tripoli",
  "America/Coral_Harbour",
  "MST",
  "Pacific/Niue",
  "Asia/Baghdad",
  "Africa/Harare",
  "America/Indiana/Knox",
  "Asia/Urumqi",
  "Navajo",
  "Africa/Maseru",
  "Asia/Seoul",
  "America/Los_Angeles",
  "Etc/GMT+5",
  "Atlantic/Azores",
  "Europe/Jersey",
  "Africa/Ndjamena",
  "Atlantic/Cape_Verde",
  "W-SU",
  "Asia/Dhaka",
  "Asia/Omsk",
  "Asia/Tel_Aviv",
  "America/Indiana/Vincennes",
  "Africa/Mbabane",
  "Antarctica/McMurdo",
  "America/Argentina/Buenos_Aires",
  "Etc/GMT+9",
  "Asia/Baku",
  "Asia/Barnaul",
  "Mexico/BajaNorte",
  "Europe/Isle_of_Man",
  "America/Indiana/Vevay",
  "America/Dawson_Creek",
  "Africa/Sao_Tome",
  "Asia/Hebron",
  "Australia/Hobart",
  "America/Tijuana",
  "Europe/London",
  "Indian/Antananarivo",
  "Mexico/BajaSur",
  "US/Eastern",
  "America/Paramaribo",
  "America/Dominica",
  "Africa/Accra",
  "Asia/Saigon",
  "Asia/Katmandu",
  "Asia/Singapore",
  "Australia/Eucla",
  "Asia/Calcutta",
  "America/Boise",
  "Antarctica/Mawson",
  "Asia/Tomsk",
  "CST6CDT",
  "Europe/Uzhgorod",
  "Asia/Almaty",
  "US/Central",
  "Australia/Lord_Howe",
  "Africa/Bujumbura",
  "America/Phoenix",
  "America/Maceio",
  "Europe/Dublin",
  "America/Indiana/Petersburg",
  "Iran",
  "UCT",
  "Europe/Zurich",
  "Pacific/Tahiti",
  "Asia/Aden",
  "Brazil/Acre",
  "America/Fortaleza",
  "US/Alaska",
  "Asia/Qatar",
  "Atlantic/South_Georgia",
  "Asia/Pyongyang",
  "Pacific/Midway",
  "Africa/Libreville",
  "CET",
  "America/Regina",
  "Pacific/Port_Moresby",
  "America/Guatemala",
  "Brazil/East",
  "America/Adak",
  "America/Havana",
  "Asia/Riyadh",
  "America/St_Lucia",
  "MET",
  "Antarctica/Davis",
  "Hongkong",
  "Japan",
  "Asia/Makassar",
  "Etc/GMT+1",
  "Pacific/Auckland",
  "Europe/Nicosia",
  "Pacific/Guam",
  "America/St_Thomas",
  "America/Montevideo",
  "America/Nassau",
  "America/Nuuk",
  "Africa/Juba",
  "Africa/Addis_Ababa",
  "America/Belize",
  "America/Denver",
  "America/Ensenada",
  "Africa/Mogadishu",
  "Kwajalein",
  "Pacific/Marquesas",
  "Etc/GMT+10",
  "Europe/Athens",
  "GMT",
  "Europe/Helsinki",
  "America/Scoresbysund",
  "Pacific/Honolulu",
  "Etc/GMT+7",
  "Asia/Atyrau",
  "America/Porto_Acre",
  "Pacific/Tongatapu",
  "Pacific/Chuuk",
  "Arctic/Longyearbyen",
  "Europe/Zaporozhye",
  "Africa/Lome",
  "America/Argentina/Cordoba",
  "America/Blanc-Sablon",
  "America/Glace_Bay",
  "Europe/Skopje",
  "Libya",
  "America/Punta_Arenas",
  "Pacific/Pitcairn",
  "America/Santa_Isabel",
  "Antarctica/Rothera",
  "Pacific/Kwajalein",
  "Europe/Tiraspol",
  "Asia/Kolkata",
  "Asia/Dubai",
  "Africa/Nairobi",
  "Africa/Malabo",
  "Asia/Gaza",
  "Africa/Banjul",
  "Etc/GMT-4",
  "Europe/Madrid",
  "Europe/Bucharest",
  "Asia/Hong_Kong",
  "Europe/Gibraltar",
  "Africa/Bissau",
  "America/Ciudad_Juarez",
  "Pacific/Johnston",
  "America/Swift_Current",
  "America/Miquelon",
  "America/Belem",
  "ROK",
  "America/Santiago",
  "Europe/Andorra",
  "Indian/Christmas",
  "Asia/Novosibirsk",
  "Europe/Istanbul",
  "Asia/Yangon",
  "Asia/Vientiane",
  "Europe/Brussels",
  "Asia/Samarkand",
  "Atlantic/Madeira",
  "Africa/Cairo",
  "Asia/Ulaanbaatar",
  "Pacific/Palau",
  "Pacific/Apia",
  "America/Sitka",
  "Australia/Currie",
  "Asia/Ust-Nera",
  "NZ-CHAT",
  "Africa/Dakar",
  "America/Guadeloupe",
  "Europe/Simferopol",
  "Europe/Berlin",
  "Indian/Reunion",
  "Europe/Ulyanovsk",
  "GB",
  "America/Iqaluit",
  "America/Lima",
  "America/Campo_Grande",
  "America/Puerto_Rico",
  "Mexico/General",
  "America/Argentina/ComodRivadavia",
  "Australia/NSW",
  "Pacific/Kanton",
  "Australia/ACT",
  "Pacific/Wallis",
  "America/Indianapolis",
  "America/St_Johns",
  "Asia/Jakarta",
  "America/Lower_Princes",
  "America/Pangnirtung",
  "Canada/Central",
  "America/Montreal",
  "Asia/Kashgar",
  "Africa/Asmera",
  "Africa/Kampala",
  "America/Antigua",
  "Etc/GMT-14",
  "America/Goose_Bay",
  "Asia/Tbilisi",
  "Africa/Niamey",
  "Europe/Tallinn",
  "Australia/Canberra",
  "Pacific/Fiji",
  "Asia/Krasnoyarsk",
  "Europe/Monaco",
  "Asia/Chongqing",
  "Asia/Yakutsk",
  "America/Barbados",
  "Europe/Belgrade",
  "America/Chihuahua",
  "America/Noronha",
  "America/Eirunepe",
  "America/Danmarkshavn",
  "America/Tortola",
  "America/Cayman",
  "US/East-Indiana",
  "Asia/Kuching",
  "Portugal",
  "America/Jamaica",
  "MST7MDT",
  "Etc/GMT-6",
  "Pacific/Bougainville",
  "Africa/Kigali",
  "Africa/Monrovia",
  "Africa/Porto-Novo",
  "Europe/Busingen",
  "Pacific/Kiritimati",
  "HST",
  "Europe/Podgorica",
  "Australia/Tasmania",
  "Asia/Pontianak",
  "Etc/GMT-12",
  "Asia/Nicosia",
  "Europe/Kyiv",
  "Etc/GMT-8",
  "Pacific/Nauru",
  "Atlantic/Jan_Mayen",
  "Etc/GMT-0",
  "Europe/Minsk",
  "Africa/Bamako",
  "America/Rio_Branco",
  "America/Argentina/Ushuaia",
  "America/North_Dakota/New_Salem",
  "Africa/Conakry",
  "America/Fort_Wayne",
  "Etc/GMT-10",
  "Pacific/Easter",
  "Asia/Karachi",
  "Etc/GMT+12",
  "Asia/Bangkok",
  "Asia/Rangoon",
  "Europe/Budapest",
  "Etc/GMT-13",
  "Pacific/Kosrae",
  "Europe/Astrakhan",
  "Antarctica/Vostok",
  "Indian/Mahe",
  "America/Argentina/Tucuman",
  "Etc/GMT+8",
  "Asia/Harbin",
  "Africa/Kinshasa",
  "Indian/Maldives",
  "US/Arizona",
  "America/Bogota",
  "America/Buenos_Aires",
  "Etc/GMT0",
  "Africa/Ceuta",
  "Australia/Yancowinna",
  "Chile/Continental",
  "Europe/Sofia",
  "Canada/Eastern",
  "America/Araguaina",
  "Eire",
  "Iceland",
  "Etc/GMT+11",
  "Asia/Damascus",
  "Asia/Tashkent",
  "Europe/Kiev",
  "Asia/Thimbu",
  "GMT+0",
  "Pacific/Yap",
  "America/Asuncion",
  "America/Cuiaba",
  "America/Martinique",
  "Etc/GMT+2",
  "Asia/Dushanbe",
  "Brazil/West",
  "Pacific/Noumea",
  "America/Guyana",
  "America/Nome",
  "Pacific/Galapagos",
  "Singapore",
  "America/Curacao",
  "America/Rosario",
  "America/Indiana/Indianapolis",
  "America/New_York",
  "Etc/GMT-5",
  "EET",
  "America/Grand_Turk",
  "Europe/Riga",
  "Pacific/Norfolk",
  "America/Nipigon",
  "Europe/Kaliningrad",
  "Africa/Algiers",
  "Asia/Anadyr",
  "Asia/Dili",
  "Europe/Copenhagen",
  "Antarctica/DumontDUrville",
  "NZ",
  "America/Fort_Nelson",
  "Europe/Ljubljana",
  "Asia/Choibalsan",
  "Asia/Amman",
  "America/Hermosillo",
  "Africa/Tunis",
  "Africa/Freetown",
  "Asia/Muscat",
  "America/Moncton",
  "Pacific/Enderbury",
  "America/Rainy_River",
  "GMT-0",
  "Pacific/Gambier",
  "America/Merida",
  "Europe/Stockholm",
  "Asia/Macau",
  "Australia/South",
  "GB-Eire",
  "America/El_Salvador",
  "Australia/Queensland",
  "Asia/Brunei",
  "America/Argentina/Catamarca",
  "America/Atka",
  "Europe/Oslo",
  "Europe/Moscow",
  "Africa/Ouagadougou",
  "Africa/Khartoum",
  "Asia/Jerusalem",
  "Etc/Greenwich",
  "Africa/Abidjan",
  "America/St_Kitts",
  "America/Porto_Velho",
  "America/Metlakatla",
  "Antarctica/Palmer",
  "America/Vancouver",
  "Australia/Lindeman",
  "US/Mountain",
  "Asia/Ashgabat",
  "Asia/Aqtau",
  "Africa/Lusaka",
  "Europe/Kirov",
  "America/Bahia_Banderas",
  "America/Anguilla",
  "Australia/Brisbane",
  "Australia/North",
  "Asia/Khandyga",
  "America/Bahia",
  "Australia/Broken_Hill",
  "Etc/GMT-11",
  "Atlantic/Faeroe",
  "America/Argentina/Mendoza",
  "America/Catamarca",
  "Indian/Kerguelen",
  "America/Sao_Paulo",
  "Pacific/Majuro",
  "Canada/Saskatchewan",
  "Europe/Vaduz",
  "Asia/Ulan_Bator",
  "Antarctica/Syowa",
  "Etc/GMT+4",
  "America/Argentina/Rio_Gallegos",
  "America/Santarem",
  "America/Port_of_Spain",
  "Egypt",
  "Atlantic/St_Helena",
  "America/North_Dakota/Beulah",
  "America/Toronto",
  "Etc/GMT-3",
  "Europe/Vienna",
  "America/Grenada",
  "America/Creston",
  "Asia/Kabul",
  "Etc/Universal",
  "Etc/GMT",
  "US/Hawaii",
  "Pacific/Funafuti",
  "Asia/Qyzylorda",
  "America/Yakutat",
  "America/Halifax",
  "America/La_Paz",
  "Africa/Douala",
  "America/St_Barthelemy",
  "Atlantic/Reykjavik",
  "Asia/Kathmandu",
  "Europe/Lisbon",
  "America/Argentina/Jujuy",
  "America/Kentucky/Louisville",
  "America/Costa_Rica",
  "Atlantic/Canary",
  "Indian/Mauritius",
  "Africa/Lagos",
  "Etc/UTC",
  "Africa/Lubumbashi",
  "America/Thunder_Bay",
  "Australia/Adelaide",
  "America/Argentina/San_Luis",
  "America/Tegucigalpa",
  "US/Michigan",
  "Australia/LHI",
  "America/Atikokan",
  "EST5EDT",
  "Africa/Djibouti",
  "America/Indiana/Marengo",
  "Canada/Newfoundland",
  "Asia/Kamchatka",
  "Asia/Qostanay",
  "EST",
  "Europe/Saratov",
  "US/Aleutian",
  "Indian/Comoro",
  "Asia/Bahrain",
  "Antarctica/Troll",
  "Europe/Zagreb",
  "America/Argentina/Salta",
  "PST8PDT",
  "Asia/Beirut",
  "Europe/Volgograd",
  "Africa/Windhoek",
  "Indian/Chagos",
  "Asia/Manila",
  "Asia/Hovd",
  "America/Detroit",
  "America/Cayenne",
  "America/North_Dakota/Center",
  "Asia/Yerevan",
  "America/Cambridge_Bay",
  "WET",
  "America/Monterrey",
  "Poland",
  "Pacific/Chatham",
  "US/Indiana-Starke",
  "America/Resolute",
  "America/St_Vincent",
  "Chile/EasterIsland",
  "Asia/Novokuznetsk",
  "Europe/Guernsey",
  "Africa/Timbuktu",
  "Africa/Gaborone",
  "Asia/Sakhalin",
  "Etc/UCT",
  "Europe/Chisinau",
  "Canada/Pacific",
  "America/Edmonton",
  "America/Kralendijk",
  "Atlantic/Faroe",
  "Pacific/Fakaofo",
  "America/Matamoros",
  "America/Cancun",
  "Europe/San_Marino",
  "Africa/Dar_es_Salaam",
  "Asia/Magadan",
  "Africa/Maputo",
  "Etc/GMT+0",
  "PRC",
  "Africa/Luanda",
  "America/Menominee",
  "Antarctica/South_Pole",
  "Europe/Bratislava",
  "America/Godthab",
  "UTC",
  "America/Whitehorse",
  "Asia/Taipei",
  "Asia/Oral",
  "Africa/Casablanca",
  "Etc/GMT-9",
  "America/Yellowknife"
]
